import LegalLayout from "@/components/feature/LegalLayout";

const sectionTitle =
  "font-bold uppercase text-[#0A0A0A] text-[20px] md:text-[24px] mt-12 mb-4 tracking-tight";
const p = "text-foreground-700 text-sm md:text-base leading-relaxed mb-3";
const list = "list-disc pl-6 text-foreground-700 text-sm md:text-base leading-relaxed mb-4 space-y-1";

export default function AGB() {
  return (
    <LegalLayout
      title="Allgemeine Geschäftsbedingungen"
      metaTitle="AGB | Zweering Elektrotechnik Emmerich am Rhein"
      metaDescription="Allgemeine Geschäftsbedingungen (AGB) der Zweering Elektrotechnik GmbH in Emmerich am Rhein."
      canonicalPath="/agb"
    >
      <p className={p}>
        Allgemeine Geschäftsbedingungen (AGB) für die Zweering Elektrotechnik GmbH
      </p>

      <h2 className={sectionTitle}>1. Geltung und Begriffsdefinitionen</h2>
      <p className={p}>
        1.1 Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für sämtliche Verträge,
        Lieferungen und Leistungen der Zweering Elektrotechnik GmbH (im Folgenden
        „Auftragnehmer").
      </p>
      <p className={p}>
        1.2 Konsumenten (Verbraucher) sind Personen, die Verträge nicht überwiegend für
        ihre gewerbliche oder berufliche Tätigkeit abschließen (§ 13 BGB). Unternehmer
        sind Personen oder Gesellschaften, die beim Vertragsabschluss in Ausübung ihrer
        selbständigen Tätigkeit handeln (§ 14 BGB).
      </p>

      <h2 className={sectionTitle}>2. Angebot, Vertragsschluss & Widerrufsrecht</h2>
      <p className={p}>
        2.1 Angebote sind unverbindlich, außer ausdrücklich als verbindlich gekennzeichnet.
      </p>
      <p className={p}>
        2.2 Der Vertrag kommt mit schriftlicher Bestätigung oder Ausführungsbeginn zustande.
      </p>
      <p className={p}>2.3 Verbraucher haben ein gesetzliches Widerrufsrecht:</p>
      <ul className={list}>
        <li>Frist: 14 Tage ab Vertragsabschluss.</li>
        <li>Der Widerruf muss eindeutig per Brief, Fax oder E-Mail erklärt werden.</li>
        <li>Es gilt ein Muster-Widerrufsformular (auf Wunsch bereitgestellt).</li>
        <li>
          Beginnt die Leistung auf Wunsch des Verbrauchers vor Ablauf der Widerrufsfrist,
          erlischt das Widerrufsrecht bei vollständiger Leistungserbringung.
        </li>
        <li>
          Folgen: Zahlungen werden innerhalb von 14 Tagen erstattet; geleistete Dienste
          anteilig abgerechnet.
        </li>
      </ul>

      <h2 className={sectionTitle}>3. Leistungsbeschreibung und Mitwirkungspflicht</h2>
      <p className={p}>3.1 Der Leistungsumfang ergibt sich aus der schriftlichen Auftragsbestätigung.</p>
      <p className={p}>3.2 Der Auftragnehmer kann Subunternehmer einsetzen.</p>
      <p className={p}>
        3.3 Der Auftraggeber hat erforderliche Mitwirkungspflichten zu erfüllen (z. B.
        Bereitstellung von Arbeitsraum, Strom, Planungsvorgaben).
      </p>
      <p className={p}>
        3.4 Bildmaterial, Zeichnungen und Pläne bleiben geistiges Eigentum und dürfen
        nicht ohne schriftliche Zustimmung verwendet werden.
      </p>

      <h2 className={sectionTitle}>4. Termine, Unterbrechungen & Notfallregelung</h2>
      <p className={p}>4.1 Verbindliche Termine nur bei ausdrücklicher schriftlicher Bestätigung.</p>
      <p className={p}>4.2 Notfälle außerhalb der Arbeitszeiten: 100 € Pauschale.</p>
      <p className={p}>
        4.3 Unterbrechung eines laufenden Einsatzes während der Arbeitszeit: 100 € Pauschale.
      </p>
      <p className={p}>4.4 Unsere regulären Arbeitszeiten:</p>
      <ul className={list}>
        <li>Mo–Do: 08:30 – 16:00</li>
        <li>Fr: 08:30 – 14:00</li>
        <li>Wochenende & gesetzliche Feiertage: geschlossen</li>
      </ul>

      <h2 className={sectionTitle}>5. Preise & Zahlungsbedingungen</h2>
      <p className={p}>5.1 Netto-Stundensätze:</p>
      <ul className={list}>
        <li>Lehrling: 29,90 €</li>
        <li>Aushilfe: 49,90 €</li>
        <li>Monteur: 59,90 €</li>
        <li>Obermonteur: 69,90 €</li>
        <li>Meister: 79,90 €</li>
        <li>Geschäftsführer Bastian Zweering: 160,00 €</li>
      </ul>
      <p className={p}>5.2 Zahlungen sind ohne Abzug sofort nach Rechnungserhalt fällig.</p>
      <p className={p}>
        5.3 Bei Zahlungsverzug fallen Verzugszinsen in gesetzlicher Höhe sowie
        Bearbeitungsgebühren und ggf. Inkasso- oder Anwaltskosten an.
      </p>

      <h2 className={sectionTitle}>6. Abnahme & Gewährleistung</h2>
      <p className={p}>6.1 Abnahme erfolgt nach Fertigstellung auf Meldung durch den Auftragnehmer.</p>
      <p className={p}>
        6.2 Erfolgt binnen 10 Tagen keine Abnahme, gilt die Leistung als abgenommen
        (sofern keine wesentlichen Mängel vorliegen).
      </p>
      <p className={p}>6.3 Gesetzliche Gewährleistung: 2 Jahre ab Abnahme.</p>

      <h2 className={sectionTitle}>7. Haftung</h2>
      <p className={p}>7.1 Voll haftbar bei Vorsatz und grober Fahrlässigkeit.</p>
      <p className={p}>
        7.2 Bei einfacher Fahrlässigkeit beschränkt auf Schäden aus Verletzung wesentlicher
        Vertragspflichten (Kardinalpflichten), maximal bis zum typischerweise
        vorhersehbaren Schaden.
      </p>
      <p className={p}>7.3 Produkthaftung bleibt unberührt.</p>

      <h2 className={sectionTitle}>8. Eigentumsvorbehalt & Pfandrechte</h2>
      <p className={p}>
        8.1 Gelieferte Waren bleiben bis zur vollständigen Bezahlung Eigentum des
        Auftragnehmers.
      </p>
      <p className={p}>
        8.2 Dem Auftragnehmer steht das gesetzliche Bauhandwerkerpfandrecht zu, sofern
        vereinbart.
      </p>

      <h2 className={sectionTitle}>9. Datenschutz</h2>
      <p className={p}>
        9.1 Personenbezogene Daten werden ausschließlich zur Vertragsabwicklung genutzt
        und im Einklang mit DSGVO und BDSG verarbeitet.
      </p>
      <p className={p}>
        9.2 Auftraggeber haben Anspruch auf Auskunft, Berichtigung, Sperrung und Löschung
        ihrer Daten.
      </p>

      <h2 className={sectionTitle}>10. Schlussbestimmungen</h2>
      <p className={p}>10.1 Es gilt deutsches Recht.</p>
      <p className={p}>
        10.2 Gerichtsstand und Erfüllungsort ist der Sitz der Zweering Elektrotechnik
        GmbH, wenn der Auftraggeber Kaufmann, juristische Person des öffentlichen Rechts
        oder öffentlich-rechtliches Sondervermögen ist.
      </p>
      <p className={p}>
        10.3 Sollten einzelne Bestimmungen unwirksam sein, bleibt die Wirksamkeit aller
        anderen Regelungen erhalten; unwirksame Regelungen werden durch solche ersetzt,
        die ihrem wirtschaftlichen Zweck am nächsten kommen.
      </p>
    </LegalLayout>
  );
}
